import { render, staticRenderFns } from "./Chuanyun.vue?vue&type=template&id=116c91ab&scoped=true&"
import script from "./Chuanyun.vue?vue&type=script&lang=js&"
export * from "./Chuanyun.vue?vue&type=script&lang=js&"
import style0 from "./Chuanyun.vue?vue&type=style&index=0&id=116c91ab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116c91ab",
  null
  
)

export default component.exports